"use client";

import type { LeadFlowAnswerPlaceholder } from "@homeinstead/schemas";
import type { PortableTextMarkComponentProps } from "@portabletext/react";

import { replaceChildrenText } from "@homeinstead/ui/components/RichText";
import { useAnswers } from "../../hooks/use-answers";
import { getAnswerText } from "../../utils/get-answer-text";
import { useLeadFlowRuntime } from "../LeadFlowRuntimeContext";

type AnswerPlaceholderMarkProps = PortableTextMarkComponentProps<
  LeadFlowAnswerPlaceholder & { _key: string }
>;

/**
 * Swaps the annotated text for the visitor's answer and keeps decorator marks
 * on that span. The annotated text is the fallback until the question is
 * answered, so server render and first paint show the fallback and the answer
 * appears once session answers load.
 */
function AnswerPlaceholderMark({
  children,
  value,
}: AnswerPlaceholderMarkProps) {
  const answers = useAnswers();
  const { answerLabels } = useLeadFlowRuntime();

  const answerText = value?.field
    ? getAnswerText(value.field, answers, answerLabels)
    : undefined;

  if (answerText) {
    return <>{replaceChildrenText(children, answerText)}</>;
  }

  return value?.hideWhenEmpty ? null : <>{children}</>;
}

export { AnswerPlaceholderMark };
